import { render } from "./MscopeNav.vue?vue&type=template&id=2242dd84&scoped=true"
import script from "./MscopeNav.vue?vue&type=script&lang=js"
export * from "./MscopeNav.vue?vue&type=script&lang=js"

import "./MscopeNav.vue?vue&type=style&index=0&id=2242dd84&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2242dd84"]])

export default __exports__